import { Link } from 'react-router-dom';
import type { Article, Category } from '@/types/content';

interface ArticleAsideProps {
  sections: Article['sections'];
  category?: Category;
  related: Article[];
}

export default function ArticleAside({ sections, category, related }: ArticleAsideProps) {
  return (
    <aside className="lg:sticky lg:top-32">
      <div className="rounded-lg border border-background-300/70 bg-background-100 p-5">
        <h2 className="flex items-center gap-2 border-b border-background-300/70 pb-3 font-heading text-sm font-bold text-foreground-950">
          <span className="flex h-4 w-4 items-center justify-center text-primary-600">
            <i className="ri-list-check-2" />
          </span>
          本档案目录
        </h2>
        <nav aria-label="文章目录" className="mt-3">
          <ol className="space-y-2.5">
            {sections.map((section, index) => (
              <li key={section.id} className="flex gap-2.5">
                <span className="font-label text-xs text-primary-600">
                  {String(index + 1).padStart(2, '0')}
                </span>
                <a
                  href={`#${section.id}`}
                  className="text-sm leading-snug text-foreground-700 transition-colors hover:text-primary-600"
                >
                  {section.heading}
                </a>
              </li>
            ))}
          </ol>
        </nav>
      </div>

      {category ? (
        <div className="mt-5 rounded-lg border border-background-300/70 bg-background-200/60 p-5">
          <h2 className="font-heading text-sm font-bold text-foreground-950">所属栏目</h2>
          <p className="mt-2 text-sm leading-relaxed text-foreground-600">{category.description}</p>
          <Link
            to={`/category/${category.slug}`}
            className="mt-3 inline-flex items-center gap-1.5 whitespace-nowrap font-label text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
          >
            查看「{category.name}」全部档案
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-arrow-right-line" />
            </span>
          </Link>
        </div>
      ) : null}

      <div className="mt-5 rounded-lg border border-background-300/70 bg-background-100 p-5">
        <h2 className="font-heading text-sm font-bold text-foreground-950">相关档案推荐</h2>
        <ul className="mt-3 space-y-3.5">
          {related.map((item) => (
            <li key={item.slug} className="border-b border-background-200 pb-3.5 last:border-b-0 last:pb-0">
              <Link
                to={`/article/${item.slug}`}
                className="font-heading text-sm font-semibold leading-snug text-foreground-800 transition-colors hover:text-primary-600"
              >
                {item.title}
              </Link>
              <span className="mt-1.5 block font-label text-xs text-foreground-500">
                约 {item.readTime} 分钟 · 热度 {item.heat.toLocaleString('zh-CN')}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </aside>
  );
}